// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261356/js/" + chunkId + "." + {"44":"cefa4188","225":"9f222b08","481":"7b667efa","486":"75c1a4da","770":"ebd50e40"}[chunkId] + ".0.6672456588958475.chunk.js";
};